import React, { useEffect } from "react";
import LoaderIcon from "../../assets/images/Loader.gif";

const Loader: React.FC = () => {
  useEffect(() => {
    // Disable scrolling when Loader is mounted
    document.body.style.overflow = "hidden";

    return () => {
      // Re-enable scrolling when Loader is unmounted
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="fixed h-full w-full bg-gray-800 bg-opacity-95 flex justify-center items-center inset-0 z-50">
      <img src={LoaderIcon} alt="Loader" width="90px" />
    </div>
  );
};

export default Loader;
